interface Translations {
    [key: string]: {
        en: string;
        hu: string;
    };
}

export const translations: Translations = {
    // Navbar
    "nav.introduction": {
        en: "Introduction",
        hu: "Bemutatkozás"
    },
    "nav.rsvp": {
        en: "RSVP",
        hu: "Visszajelzés"
    },
    "nav.location": {
        en: "Location",
        hu: "Helyszín"
    },
    "nav.gallery": {
        en: "Gallery",
        hu: "Galéria"
    },
    "nav.wishes": {
        en: "Wishes",
        hu: "Jókívánságok"
    },

    // Introduction
    "intro.title": {
        en: "Birthday Celebration!",
        hu: "Születésnapi Ünnepség!"
    },
    "intro.subtitle": {
        en: "Hi, I'm Mark, and I'm excited to celebrate my 30th birthday with all of you!",
        hu: "Szia, Mark vagyok, és nagyon várom, hogy veletek ünnepelhessem a 30. születésnapomat!"
    },
    "intro.description": {
        en: "Join us for an amazing celebration!",
        hu: "Tarts velünk egy fantasztikus ünneplésre!"
    },
    "intro.details": {
        en: "Let's make this birthday unforgettable together.",
        hu: "Tegyük együtt feledhetetlenné ezt a születésnapot!"
    },
    "intro.whatCanYouDo": {
        en: "What can you do here?",
        hu: "Mit tehetsz itt?"
    },

    // Features
    "features.photos.title": {
        en: "Upload pictures",
        hu: "Képek feltöltése"
    },
    "features.photos.description": {
        en: "Share your pre-party and party pictures with everyone.",
        hu: "Oszd meg a parti előtti és alatti képeidet mindenkivel."
    },
    "features.wishes.title": {
        en: "Leave wishes",
        hu: "Jókívánságok"
    },
    "features.wishes.description": {
        en: "Leave your best wishes on the board for everyone to see.",
        hu: "Írj jókívánságokat, amiket mindenki láthat."
    },
    "features.location.title": {
        en: "Suggest places",
        hu: "Helyszínek ajánlása"
    },
    "features.location.description": {
        en: "Help us pick the perfect location for the celebration.",
        hu: "Segíts kiválasztani a tökéletes helyszínt az ünnepléshez."
    },
    "features.guestlist.title": {
        en: "Join guest list",
        hu: "Vendéglista"
    },
    "features.guestlist.description": {
        en: "Let us know when you can come to the party.",
        hu: "Jelezd, mikor tudsz jönni a partira."
    },

    // Are You Coming
    "rsvp.title": {
        en: "Let me know if you're coming!",
        hu: "Jelezd, hogy jössz-e!"
    },
    "rsvp.name": {
        en: "Your Name:",
        hu: "Neved:"
    },
    "rsvp.date": {
        en: "When are you coming?",
        hu: "Mikor jössz?"
    },
    "rsvp.notes": {
        en: "Additional Notes:",
        hu: "További megjegyzések:"
    },
    "rsvp.notes.placeholder": {
        en: "Any dietary requirements or other notes?",
        hu: "Étkezési igények vagy egyéb megjegyzések?"
    },
    "rsvp.submit": {
        en: "Confirm Attendance",
        hu: "Részvétel megerősítése"
    },
    "rsvp.guestlist.title": {
        en: "Who's Coming?",
        hu: "Kik jönnek?"
    },
    "rsvp.guestlist.total": {
        en: "🎉 Total Confirmed:",
        hu: "🎉 Összes visszajelzés:"
    },
    "rsvp.guestlist.guests": {
        en: "guests",
        hu: "vendég"
    },
    "rsvp.guestlist.coming": {
        en: "📅 Coming on:",
        hu: "📅 Érkezés:"
    },

    // RSVP Error Messages
    "rsvp.error.loading": {
        en: "Error loading guest list. Please try again.",
        hu: "Hiba a vendéglista betöltésekor. Kérjük, próbáld újra."
    },
    "rsvp.error.submit": {
        en: "Error submitting RSVP. Please try again.",
        hu: "Hiba a visszajelzés elküldésekor. Kérjük, próbáld újra."
    },
    "rsvp.email": {
        en: "Email Address:",
        hu: "Email cím:"
    },
    "rsvp.phone": {
        en: "Phone Number:",
        hu: "Telefonszám:"
    },

    // Send Pic
    "gallery.title": {
        en: "Send a Pic",
        hu: "Küldj egy képet"
    },
    "gallery.name": {
        en: "Your Name:",
        hu: "Neved:"
    },
    "gallery.select": {
        en: "Select Picture:",
        hu: "Válassz képet:"
    },
    "gallery.comment": {
        en: "Comment (optional):",
        hu: "Megjegyzés (opcionális):"
    },
    "gallery.submit": {
        en: "Upload Picture",
        hu: "Kép feltöltése"
    },

    // Gallery Error Messages
    "gallery.error.loading": {
        en: "Error loading images. Please try again.",
        hu: "Hiba a képek betöltésekor. Kérjük, próbáld újra."
    },
    "gallery.error.upload": {
        en: "Error uploading image. Please try again.",
        hu: "Hiba a kép feltöltésekor. Kérjük, próbáld újra."
    },

    // Location
    "location.search": {
        en: "Search for places...",
        hu: "Helyszínek keresése..."
    },
    "location.suggested": {
        en: "Suggested Places",
        hu: "Javasolt helyszínek"
    },
    "location.vote": {
        en: "Vote",
        hu: "Szavazás"
    },

    // Location Error Messages
    "location.error.loading": {
        en: "Error loading locations. Please try again.",
        hu: "Hiba a helyszínek betöltésekor. Kérjük, próbáld újra."
    },
    "location.error.create": {
        en: "Error creating location. Please try again.",
        hu: "Hiba a helyszín létrehozásakor. Kérjük, próbáld újra."
    },
    "location.error.vote": {
        en: "Error submitting vote. Please try again.",
        hu: "Hiba a szavazat elküldésekor. Kérjük, próbáld újra."
    },

    // Wishes
    "wishes.title": {
        en: "Send Your Best Wishes",
        hu: "Küldj jókívánságokat"
    },
    "wishes.name": {
        en: "Your Name",
        hu: "Neved"
    },
    "wishes.message": {
        en: "Your Wish",
        hu: "Jókívánságod"
    },
    "wishes.submit": {
        en: "Send Wish",
        hu: "Küldés"
    },
    "wishes.board.title": {
        en: "Birthday Wishes",
        hu: "Születésnapi Kívánságok"
    },
    "wishes.board.list": {
        en: "All Wishes",
        hu: "Összes Kívánság"
    },
    "wishes.newWish": {
        en: "Send a New Wish",
        hu: "Új Kívánság Küldése"
    },
    "wishes.modal.title": {
        en: "Send Your Best Wishes",
        hu: "Küldj Jókívánságokat"
    },

    // Wishes Error Messages
    "wishes.error.loading": {
        en: "Error loading wishes. Please try again.",
        hu: "Hiba a kívánságok betöltésekor. Kérjük, próbáld újra."
    },
    "wishes.error.submit": {
        en: "Error submitting wish. Please try again.",
        hu: "Hiba a kívánság elküldésekor. Kérjük, próbáld újra."
    },
    "wishes.title.input": {
        en: "Title of Your Wish:",
        hu: "Kívánságod címe:"
    },
    "wishes.title.placeholder": {
        en: "Enter a title for your wish...",
        hu: "Add meg a kívánságod címét..."
    },
    "wishes.message.placeholder": {
        en: "Write your wish here...",
        hu: "Írd ide a kívánságodat..."
    }
};